export const months: any = [
  'Leden',
  'Únor',
  'Březen',
  'Duben',
  'Květen',
  'Červen',
  'Červenec',
  'Srpen',
  'Září',
  'Říjen',
  'Listopad',
  'Prosinec'
];

export const days: any = ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'];

export const daysShort: any = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];



// WEBPACK FOOTER //
// ./src/modules/hr-overview/_overviewEnums.ts